import React from "react";
import { Props } from "./types";
import { User } from "./user";
import { RemoveIcon } from "./removeIcon";
import styles from "./styles.scss";

function Resource({ resource, select }: Props) {
  return (
    <div className={styles.resource} onClick={select}>
      <User resource={resource} />
      {select && (
        <div className={styles.iconBox}>
          <RemoveIcon className={styles.icon} />
        </div>
      )}
    </div>
  );
}

export { Resource };
